var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecksRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.701 10.714l-11.2 11a1 1 0 01-1.402 0L1.299 17A1 1 0 112.7 15.574l4.1 4.025L17.3 9.286a1 1 0 011.402 1.428H18.7zm12.013-1.415a1 1 0 00-1.415-.013L18.799 19.6l-2.354-2.313a1 1 0 10-1.401 1.428l3.054 3a1 1 0 001.402 0l11.2-11a.999.999 0 00.014-1.415z"
  })));
}
export default SvgChecksRegular;